import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { SwiperContainer } from 'swiper/element';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class SliderComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef) { }
  
  @Input('breakpoints') breakpoints: any = {};
  @Input('sliderLength') sliderLength: number = 0;  

  @Output() onChangeIndex = new EventEmitter<number>();
  @Output() onChangeSlides = new EventEmitter<number>();

  @ViewChild('swiper') swiper!: ElementRef<SwiperContainer>;

  index: number = 0;
  slides: number | "auto" | undefined = 0;

  // Configurazione  
  activeIndex = 0;
  visibleSlideIndexes: number[] = [];

  ngAfterViewInit(): void {

    // Recupero il breakpoint
    const currentBreakpoint = this.swiper?.nativeElement.swiper.currentBreakpoint;    

    // Se ho un breakpoint recupero le slide per view che ho impostato
    if (currentBreakpoint && this.swiper.nativeElement.swiper.params.breakpoints) {
      this.slides = this.swiper.nativeElement.swiper.params.breakpoints[currentBreakpoint].slidesPerView as number;
      this.index = this.slides;
    } else {
      this.slides = this.swiper.nativeElement.swiper.params.slidesPerView as number;
      this.index = this.slides;
    }    

    // Style per mostrare le slide oltre la vista
    var style = document.createElement('style')
    style.innerHTML = `.swiper.swiper-horizontal { overflow: visible }`;
    this.swiper.nativeElement.shadowRoot!.appendChild(style);

    // Ciclo per le slide che ci sono
    this.swiper.nativeElement.swiper.slides.map(slide => {

      // Style per nascondere il preloader
      var style = document.createElement('style')
      style.innerHTML = `.swiper-lazy-preloader { display: none !important }`;
      slide.shadowRoot!.appendChild(style);

    })    

    // Autoplay config
    this.swiper.nativeElement.autoplay = {
      delay: 3000,
      disableOnInteraction: true
    }
    // this.swiper.nativeElement.swiper.autoplay.start();
      

    // Controllo quando viene effettuato un cambio slide tramite il drag
    this.swiper.nativeElement.swiper.on('slideChange', (swiper: any) => {      

      // Recupero l'indice precedente
      let prevIndex = this.index - +this.slides! || 0;
      // Recupero il nuovo indice
      let currentIndex = swiper.activeIndex;

      // Se il nuovo indice è maggiore rispetto a quello vecchio sta andando avanti
      if (currentIndex > prevIndex) {
        this.index = this.index + (currentIndex - prevIndex);
      } else {
        this.index = this.index - (prevIndex - currentIndex);
      }   
      
      // Segnalo al DOM che ci sono stati dei cambiamenti e quindi deve aggiornarsi
      this.cdr.detectChanges();
      
      this.onChangeIndex.emit(currentIndex);

    });

    this.onChangeSlides.emit(this.slides);

    this.cdr.detectChanges();
  }

  onNext() {    
    this.swiper.nativeElement.swiper.slideNext();    
  }

  onPrev() {
    this.swiper.nativeElement.swiper.slidePrev();
  }

}